import { MapRoadWorksFilters } from "../../../../../stateManagement/reducers/maps/MapRoadWorksSlice";
import { configureMapFiltersStateFromConfig } from "../filters/mapFiltersFunctions";
import { MapFiltersConfig } from "../filters/types";

export const mapFiltersConfig = [
    {
        caption: "Состояние работ",
        type: "layer",
        format: "list-checkbox",
        operation: "equals",
        hasSearch: false,
        canBeIgnored: false,
        canIncludeNull: false,
        fieldName: "WorksState",
        values: [
            {
                caption: "Запланированные",
                value: "planned",
                checked: true
            },
            {
                caption: "Проведённые",
                value: "finished",
                checked: true
            },
        ]
    },
    {
        caption: "Дата начала работ",
        type: "value",
        format: "calendar",
        operation: "between",
        hasSearch: false,
        canBeIgnored: true,
        canIncludeNull: false,
        fieldName: "StartDate",
    },
    {
        caption: "Вид работ",
        type: "value",
        format: "list-checkbox",
        operation: "equals",
        hasSearch: false,
        canBeIgnored: true,
        canIncludeNull: false,
        fieldName: "EventStandartTypeId",
        values: [
            {
                caption: "Строительство",
                value: 2,
                color: "#ff7f0e"
            },
            {
                caption: "Реконструкция",
                value: 3,
                color: "#2ca02c"
            },
            {
                caption: "Капитальный ремонт",
                value: 4,
                color: "#d62728"
            },
            {
                caption: "Ремонт",
                value: 5,
                color: "#9467bd"
            }
        ],
    }
] as const satisfies MapFiltersConfig;

export const initialMapFiltersState = configureMapFiltersStateFromConfig(mapFiltersConfig) as MapRoadWorksFilters
export const initialActiveTabs = configureMapFiltersStateFromConfig(mapFiltersConfig)